import React from "react";
import PropTypes from 'prop-types';

import { Button, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const CloseButton = ({handleCloseClick, isSaving, label, ...props}) => {
    if (label) {
        return(
            <Button
                variant="outlined"
                size="small"
                onClick={ () => handleCloseClick()}
                disabled={isSaving}
                startIcon={<CloseIcon />}
                {...props}
            >
                    {label}
            </Button>
        )
    }
    return(
        <IconButton
            size="small"
            onClick={ () => handleCloseClick()}
            disabled={isSaving}
            title="Закрыть"
            {...props}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    )
}

CloseButton.propTypes = {
    handleCloseClick: PropTypes.func,
};

export default CloseButton;
